import { cx } from '@mage-ui/styled-system/css';
import {
  detailInnerSectionHeading,
  text,
  title,
} from '@mage-ui/styled-system/recipes';

export const DetailInnerSectionHeading = ({ data, isRelation, ...props }) => {
  const classes = detailInnerSectionHeading();
  return (
    <div className={classes.root} {...props}>
      {data.title &&
        (isRelation ? (
          <h3
            className={cx(title({ size: '6', weight: 'bold' }), classes.title)}
          >
            {data.title}
          </h3>
        ) : (
          <h2
            className={cx(title({ size: '6', weight: 'bold' }), classes.title)}
          >
            {data.title}
          </h2>
        ))}
      {data.update && (
        <p className={cx(text({ size: '2', weight: 'bold' }), classes.update)}>
          {data.update}
        </p>
      )}
      {data.subtitle &&
        (isRelation ? (
          <h4
            className={cx(
              text({ size: '2', weight: 'bold' }),
              classes.subtitle,
            )}
          >
            {data.subtitle}
          </h4>
        ) : (
          <h3
            className={cx(
              text({ size: '2', weight: 'bold' }),
              classes.subtitle,
            )}
          >
            {data.subtitle}
          </h3>
        ))}
      {data.description && (
        <div
          className={cx(
            text({ size: '2', weight: 'bold' }),
            classes.description,
          )}
          dangerouslySetInnerHTML={{ __html: data.description }}
        />
      )}
      {data.intro && (
        <div
          className={cx(text({ size: '2', weight: 'medium' }), classes.intro)}
          dangerouslySetInnerHTML={{ __html: data.intro }}
        />
      )}
    </div>
  );
};
